import {Injectable} from '@angular/core';
import {BaseService} from '../core/service/base.service';
import {HttpClient, HttpHeaders, HttpParams} from '@angular/common/http';
import {PurchaseProcess} from '../model/purchase-process';
import {Observable} from 'rxjs';
import {HeaderConstants} from '../core/utils/headers.constants';

@Injectable()
export class PurchaseProcessService extends BaseService<PurchaseProcess> {

  serviceUrl(): string {
    return `/api/t/{tenant}/purchase-processes`;
  }

  constructor(protected http: HttpClient) {
    super(http);
  }

  getWithDocuments(id: number): Observable<PurchaseProcess> {
    return this.http.get<PurchaseProcess>(`${this.serviceUrl()}/${id}/with-documents`);
  }
}
